import { render, staticRenderFns } from "./regulations.vue?vue&type=template&id=fb9246b2&scoped=true"
import script from "./regulations.vue?vue&type=script&lang=js"
export * from "./regulations.vue?vue&type=script&lang=js"
import style0 from "./regulations.vue?vue&type=style&index=0&id=fb9246b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb9246b2",
  null
  
)

export default component.exports